import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { StorageService } from "../services/storage.service";
import { AuthService } from "src/app/services/auth.service";

export const userValidatedGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const sessionStorage = inject(StorageService);
  if (sessionStorage.getUser() !== null) {
    const user = JSON.parse(sessionStorage.getUser()!);
    if (user?.npi) {
      authService.redirectToSSOLoginPage();
      return false;
    }
    return true;
  } else {
    authService.redirectToSSOLoginPage();
    return false;
  }
};
